import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import swal from 'sweetalert2'

import useSetState from 'hooks/useSetState'
import { digObject } from 'functions/utilities'

import * as campaignProposalSectionActions from 'agency/redux/modules/campaignProposalSection'

const updateSection = (props, state, setEditing) => {
  const {
    customSection, dataSourceType, updateCampaignProposalSection,
  } = props

  const { body, data, title } = state

  const updateFn = dataSourceType === 'CampaignProposal' ? updateCampaignProposalSection : null
  if (updateFn){
    const updatedSection = {
      id: customSection.id,
      body,
      data: JSON.stringify(data),
      title,
    }

    updateFn(updatedSection).then(() => {
      setEditing(false)
    })
  }
}

const deleteSection = (section, props) => {
  const { dataSourceType, deleteCampaignProposalSection } = props

  const deleteFn = dataSourceType === 'CampaignProposal' ? deleteCampaignProposalSection : null
  if (deleteFn) deleteFn(section)
}

const confirmDelete = (section, props) => {
  swal.fire({
    title: 'Delete Section?',
    text: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it.',
    confirmButtonColor: '#DD6B55',
    animation: 'slide-from-top',
  }).then(({ value }) => {
    if (value){
      deleteSection(section, props)
    }
  })
}

const createLink = (externalLink, state, setState) => {
  const externalLinks = [...digObject(state, 'data.external_links', [])]
  externalLinks.push(externalLink)

  setState({
    data: {
      ...state.data,
      external_links: externalLinks,
    },
  })
}

const deleteLink = (externalLink, state, setState) => {
  const externalLinks = [...digObject(state, 'data.external_links', [])]

  setState({
    data: {
      ...state.data,
      external_links: externalLinks.filter(link => link.key !== externalLink.key),
    },
  })
}

const toggleEdit = (props, setEditing) => {
  const { editMode } = props
  if (editMode){
    setEditing(editing => !editing)
  }
}

const setupState = (props, setState) => {
  const { customSection: { body, data, title } } = props

  setState({
    body: body || '',
    data: data || {},
    title: title || '',
  })
}

const resetState = (props, setState, setEditing) => {
  setupState(props, setState)
  setEditing(false)
}

const defaultState = {
  body: '',
  data: {},
  title: '',
}

const CustomSectionWrapper = (props) => {
  const {
    customSection, deleting, updating, render,
  } = props

  const [state, setState] = useSetState(defaultState)

  // Need the callback fn to set opposite state
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    setupState(props, setState)
  }, [customSection.id])

  return render({
    callbacks: {
      createLink: externalLink => createLink(externalLink, state, setState),
      deleteLink: externalLink => deleteLink(externalLink, state, setState),
      deleteSection: section => confirmDelete(section, props),
      reset: () => resetState(props, setState, setEditing),
      toggleEdit: () => toggleEdit(props, setEditing),
      updateSection: () => updateSection(props, state, setEditing),
    },
    deleting,
    editing,
    section: customSection,
    setState,
    state,
    updating,
  })
}

CustomSectionWrapper.propTypes = {}

function mapStateToProps(state){
  return {
    deleting: state.campaignProposalSections.deleting,
    updating: state.campaignProposalSections.updating,
  }
}

const mapDispatchToProps = {
  deleteCampaignProposalSection: campaignProposalSectionActions.deleteCampaignProposalSection,
  updateCampaignProposalSection: campaignProposalSectionActions.updateCampaignProposalSection,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSectionWrapper)
